export const allManga = [
  {
    id: '1',
    title: '我的野蛮女友',
    slug: 'my-sassy-girl',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20comic%20cover%20art%2C%20beautiful%20couple%20illustration%2C%20soft%20pastel%20color%20palette%2C%20minimalist%20white%20background%2C%20clean%20editorial%20style%2C%20Korean%20manhwa%20art%2C%20delicate%20linework%2C%20emotional%20expressions%2C%20modern%20digital%20illustration%20with%20warm%20lighting&width=600&height=800&seq=manga-cover-01&orientation=portrait',
    category: '浪漫爱情',
    categorySlug: 'romance',
    rating: 9.5,
    status: '连载中',
    author: '李智恩',
    description: '讲述了一个普通大学生与一位性格强势的女生之间发生的浪漫爱情故事。两人从最初的误会和冲突，到逐渐了解彼此，最终走到一起的感人历程。故事情节跌宕起伏，画风精美细腻，是韩国漫画中浪漫爱情题材的经典之作。',
    totalChapters: 89,
    views: '1280万',
    tags: ['校园', '恋爱', '喜剧', '治愈'],
    chapters: [
      { no: 89, title: '最终的决定', date: '2026-07-03' },
      { no: 88, title: '意外的告白', date: '2026-06-28' },
      { no: 87, title: '雨中的承诺', date: '2026-06-24' },
      { no: 86, title: '心动的瞬间', date: '2026-06-20' },
      { no: 85, title: '重新开始的勇气', date: '2026-06-16' },
    ],
  },
  {
    id: '2',
    title: '热血高校',
    slug: 'hot-blooded-high-school',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20action%20school%20comic%20cover%2C%20dynamic%20fight%20scene%20illustration%2C%20intense%20red%20and%20dark%20tones%2C%20minimal%20background%2C%20clean%20graphic%20style%2C%20Korean%20manhwa%20art%2C%20bold%20linework%2C%20dramatic%20lighting%2C%20modern%20digital%20illustration&width=600&height=800&seq=manga-cover-02&orientation=portrait',
    category: '热血动作',
    categorySlug: 'action',
    rating: 9.2,
    status: '连载中',
    author: '朴成浩',
    description: '以韩国高中为背景的热血格斗漫画，主角从小习武，进入高中后为了保护朋友和正义，不断挑战各路强敌。作品以精彩的打斗场面和深刻的人物刻画著称，每一场战斗都让人热血沸腾。',
    totalChapters: 156,
    views: '2100万',
    tags: ['格斗', '校园', '动作', '热血'],
    chapters: [
      { no: 156, title: '最终决战', date: '2026-07-02' },
      { no: 155, title: '觉醒的力量', date: '2026-06-29' },
      { no: 154, title: '宿命的对决', date: '2026-06-25' },
      { no: 153, title: '不屈的意志', date: '2026-06-22' },
      { no: 152, title: '传承', date: '2026-06-18' },
    ],
  },
  {
    id: '3',
    title: '奇幻之旅',
    slug: 'fantasy-journey',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20adventure%20comic%20cover%2C%20magical%20world%20illustration%2C%20soft%20ethereal%20light%20color%20palette%2C%20minimalist%20white%20background%2C%20clean%20art%20style%2C%20Korean%20manhwa%20art%2C%20delicate%20fantasy%20elements%2C%20modern%20digital%20illustration&width=600&height=800&seq=manga-cover-03&orientation=portrait',
    category: '奇幻冒险',
    categorySlug: 'fantasy',
    rating: 9.7,
    status: '已完结',
    author: '金敏秀',
    description: '一个普通少年意外穿越到魔法世界，发现自己拥有传说中的力量。在寻找回家之路的过程中，他结识了众多伙伴，经历了无数冒险，逐渐成长为拯救两个世界的关键人物。全篇已完结，共180话，画风精美，世界观宏大。',
    totalChapters: 180,
    views: '3500万',
    tags: ['穿越', '魔法', '冒险', '成长'],
    chapters: [
      { no: 180, title: '终章：归途', date: '2026-05-20' },
      { no: 179, title: '最后的魔法', date: '2026-05-15' },
      { no: 178, title: '世界的真相', date: '2026-05-10' },
      { no: 177, title: '决战的序曲', date: '2026-05-05' },
      { no: 176, title: '团结的力量', date: '2026-04-30' },
    ],
  },
  {
    id: '4',
    title: '悬疑之夜',
    slug: 'mystery-night',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20thriller%20mystery%20comic%20cover%2C%20dark%20atmospheric%20illustration%2C%20noir%20style%20with%20subtle%20highlights%2C%20minimal%20dark%20background%2C%20clean%20graphic%20art%2C%20Korean%20manhwa%20style%2C%20moody%20lighting%2C%20modern%20digital%20illustration&width=600&height=800&seq=manga-cover-04&orientation=portrait',
    category: '悬疑推理',
    categorySlug: 'mystery',
    rating: 9.0,
    status: '连载中',
    author: '郑宇镇',
    description: '一座被迷雾笼罩的小镇上，接连发生离奇案件。刑警韩在宇在调查过程中，逐渐发现所有案件都指向二十年前的一桩悬案。扣人心弦的推理过程，层层递进的悬念设置，让读者欲罢不能。',
    totalChapters: 67,
    views: '890万',
    tags: ['推理', '悬疑', '刑侦', '犯罪'],
    chapters: [
      { no: 67, title: '迷雾中的真相', date: '2026-07-01' },
      { no: 66, title: '最后的线索', date: '2026-06-27' },
      { no: 65, title: '嫌疑人的自白', date: '2026-06-23' },
      { no: 64, title: '暗处的眼睛', date: '2026-06-19' },
      { no: 63, title: '新的案件', date: '2026-06-15' },
    ],
  },
  {
    id: '5',
    title: '恋爱方程式',
    slug: 'love-equation',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20comedy%20cover%20with%20couple%20on%20campus%2C%20bright%20warm%20color%20palette%2C%20minimalist%20white%20background%2C%20clean%20Korean%20manhwa%20art%20style%2C%20youthful%20fresh%20atmosphere%2C%20modern%20digital%20illustration%2C%20delicate%20expressions&width=600&height=800&seq=manga-cover-05&orientation=portrait',
    category: '浪漫爱情',
    categorySlug: 'romance',
    rating: 8.9,
    status: '连载中',
    author: '崔秀英',
    description: '数学系天才少女与艺术系浪漫学长的校园恋爱故事。当理性遇到感性，公式碰到画笔，两个完全不同世界的人会擦出怎样的火花？甜蜜治愈的恋爱漫画，让你重拾对爱情的期待。',
    totalChapters: 89,
    views: '760万',
    tags: ['校园', '恋爱', '治愈', '喜剧'],
    chapters: [
      { no: 89, title: '心动的答案', date: '2026-07-03' },
      { no: 88, title: '不期而遇', date: '2026-06-29' },
      { no: 87, title: '画中的你', date: '2026-06-25' },
      { no: 86, title: '方程式与彩虹', date: '2026-06-21' },
      { no: 85, title: '偷偷的心意', date: '2026-06-17' },
    ],
  },
  {
    id: '6',
    title: '王者之路',
    slug: 'road-to-king',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20martial%20arts%20action%20cover%2C%20powerful%20fighter%20illustration%2C%20warm%20amber%20and%20dark%20tones%2C%20minimalist%20background%2C%20clean%20graphic%20Korean%20manhwa%20art%2C%20intense%20atmosphere%2C%20bold%20dynamic%20composition&width=600&height=800&seq=manga-cover-06&orientation=portrait',
    category: '热血动作',
    categorySlug: 'action',
    rating: 9.1,
    status: '连载中',
    author: '姜东元',
    description: '从底层崛起的格斗天才，一步步征服地下格斗界，最终走向世界舞台的传奇故事。拳拳到肉的真实打击感，细腻的人物成长弧线，让这部作品成为近年来最受欢迎的格斗漫画之一。',
    totalChapters: 156,
    views: '1800万',
    tags: ['格斗', '竞技', '成长', '热血'],
    chapters: [
      { no: 156, title: '世界之巅', date: '2026-07-02' },
      { no: 155, title: '最后的对手', date: '2026-06-28' },
      { no: 154, title: '冠军的荣耀', date: '2026-06-24' },
      { no: 153, title: '极限突破', date: '2026-06-20' },
      { no: 152, title: '宿敌重逢', date: '2026-06-16' },
    ],
  },
  {
    id: '7',
    title: '星辰大海',
    slug: 'sea-of-stars',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20sci-fi%20space%20opera%20cover%2C%20futuristic%20spacecraft%20illustration%2C%20dreamy%20cosmic%20color%20palette%2C%20minimalist%20dark%20background%2C%20clean%20Korean%20manhwa%20art%20style%2C%20peaceful%20starlit%20atmosphere%2C%20modern%20digital%20illustration&width=600&height=800&seq=manga-cover-07&orientation=portrait',
    category: '科幻未来',
    categorySlug: 'scifi',
    rating: 9.3,
    status: '已完结',
    author: '韩智浩',
    description: '公元2350年，人类已经遍布银河系。年轻的星际探险家尹星辰在探索未知星域时，发现了古老外星文明的遗迹，一场关乎人类命运的星际冒险就此展开。硬核科幻设定配合温情的人物故事，堪称韩国科幻漫画的里程碑之作。',
    totalChapters: 120,
    views: '1500万',
    tags: ['科幻', '太空', '冒险', '探索'],
    chapters: [
      { no: 120, title: '回归地球', date: '2026-06-15' },
      { no: 119, title: '文明的火种', date: '2026-06-10' },
      { no: 118, title: '最终的真相', date: '2026-06-05' },
      { no: 117, title: '宇宙的答案', date: '2026-05-30' },
      { no: 116, title: '最后的跃迁', date: '2026-05-25' },
    ],
  },
  {
    id: '8',
    title: '恶女的重生',
    slug: 'villainess-reborn',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20historical%20drama%20cover%20with%20elegant%20female%20noble%2C%20warm%20amber%20and%20rose%20palette%2C%20minimalist%20background%2C%20clean%20Korean%20manhwa%20art%20style%2C%20dramatic%20atmosphere%2C%20modern%20digital%20illustration&width=600&height=800&seq=manga-cover-08&orientation=portrait',
    category: '剧情重生',
    categorySlug: 'drama',
    rating: 9.4,
    status: '连载中',
    author: '尹美莱',
    description: '被所有人背叛后惨死的帝国第一恶女，带着记忆重生回到十五年前。这一次，她不再做任人宰割的棋子，而是要用自己的智慧和手段改写命运。精彩的宫廷斗争，细腻的人物关系，让人一口气追完停不下来。',
    totalChapters: 123,
    views: '2800万',
    tags: ['重生', '宫廷', '复仇', '女性'],
    chapters: [
      { no: 123, title: '命运的重逢', date: '2026-07-02' },
      { no: 122, title: '棋局之外', date: '2026-06-28' },
      { no: 121, title: '隐藏的盟友', date: '2026-06-24' },
      { no: 120, title: '反击的号角', date: '2026-06-20' },
      { no: 119, title: '真相大白', date: '2026-06-16' },
    ],
  },
  {
    id: '9',
    title: '搞笑一家人',
    slug: 'funny-family',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20comedy%20family%20cover%20with%20funny%20characters%2C%20bright%20cheerful%20color%20palette%2C%20minimalist%20white%20background%2C%20clean%20Korean%20manhwa%20art%20style%2C%20humorous%20atmosphere%2C%20modern%20digital%20illustration&width=600&height=800&seq=manga-cover-09&orientation=portrait',
    category: '搞笑日常',
    categorySlug: 'comedy',
    rating: 8.8,
    status: '连载中',
    author: '权泰浩',
    description: '一家四口的爆笑日常生活，爸爸是笨拙的公司职员，妈妈是精明的主妇，上高中的姐姐和初中的弟弟每天上演各种啼笑皆非的故事。轻松治愈，每话都能让你笑出声。',
    totalChapters: 210,
    views: '4200万',
    tags: ['搞笑', '日常', '家庭', '治愈'],
    chapters: [
      { no: 210, title: '暑假的最后一天', date: '2026-07-03' },
      { no: 209, title: '爸爸的秘密计划', date: '2026-06-30' },
      { no: 208, title: '妈妈的反击', date: '2026-06-27' },
      { no: 207, title: '姐弟大作战', date: '2026-06-24' },
      { no: 206, title: '误会大集合', date: '2026-06-21' },
    ],
  },
  {
    id: '10',
    title: '幽灵教室',
    slug: 'ghost-classroom',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20horror%20school%20cover%2C%20dark%20eerie%20atmosphere%2C%20ghostly%20illustration%2C%20minimalist%20dark%20background%2C%20clean%20Korean%20manhwa%20art%20style%2C%20chilling%20mood%2C%20modern%20digital%20illustration&width=600&height=800&seq=manga-cover-10&orientation=portrait',
    category: '恐怖灵异',
    categorySlug: 'horror',
    rating: 8.7,
    status: '已完结',
    author: '宋贤宇',
    description: '一所废弃学校的深夜探险，五个学生意外唤醒了沉睡的怨灵。随着超自然现象愈演愈烈，他们必须揭开学校隐藏的黑暗历史，才能活着走出这座被诅咒的教学楼。恐怖的氛围营造极为出色。',
    totalChapters: 98,
    views: '620万',
    tags: ['恐怖', '灵异', '校园', '悬疑'],
    chapters: [
      { no: 98, title: '最后的钟声', date: '2026-05-15' },
      { no: 97, title: '封印', date: '2026-05-10' },
      { no: 96, title: '真相的代价', date: '2026-05-05' },
      { no: 95, title: '最后的幸存者', date: '2026-04-30' },
      { no: 94, title: '黑暗中的身影', date: '2026-04-25' },
    ],
  },
  {
    id: '11',
    title: '樱花树下',
    slug: 'under-the-cherry-blossom',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20spring%20cover%20with%20cherry%20blossoms%2C%20soft%20pink%20pastel%20palette%2C%20minimalist%20white%20background%2C%20clean%20Korean%20manhwa%20art%20style%2C%20gentle%20romantic%20atmosphere%2C%20modern%20digital%20illustration&width=600&height=800&seq=manga-cover-11&orientation=portrait',
    category: '浪漫爱情',
    categorySlug: 'romance',
    rating: 9.1,
    status: '连载中',
    author: '张恩静',
    description: '两个从小在樱花树下长大的青梅竹马，在青春最美好的年纪重新相遇。初春的樱花、夏日的蝉鸣、秋天的落叶、冬日的初雪，四季轮回中，两颗心慢慢靠近。',
    totalChapters: 56,
    views: '510万',
    tags: ['纯爱', '青梅竹马', '治愈', '青春'],
    chapters: [
      { no: 56, title: '樱花再开时', date: '2026-07-02' },
      { no: 55, title: '冬日的告白', date: '2026-06-28' },
      { no: 54, title: '初雪之约', date: '2026-06-24' },
      { no: 53, title: '回忆的碎片', date: '2026-06-20' },
      { no: 52, title: '秋日私语', date: '2026-06-16' },
    ],
  },
  {
    id: '12',
    title: '机械纪元',
    slug: 'mecha-era',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20sci-fi%20mecha%20cover%2C%20giant%20robot%20illustration%2C%20futuristic%20industrial%20style%2C%20minimalist%20dark%20background%2C%20clean%20Korean%20manhwa%20art%2C%20epic%20scale%2C%20modern%20digital%20illustration&width=600&height=800&seq=manga-cover-12&orientation=portrait',
    category: '科幻未来',
    categorySlug: 'scifi',
    rating: 9.0,
    status: '连载中',
    author: '赵贤俊',
    description: '近未来世界，人类与巨型机甲共存。少年驾驶员金泰浩在一次意外中获得了传说中的远古机甲，从此被卷入了一场关乎人类命运的战争。炫酷的机甲设计和宏大的世界观令人目不暇接。',
    totalChapters: 88,
    views: '1300万',
    tags: ['机甲', '科幻', '战争', '热血'],
    chapters: [
      { no: 88, title: '觉醒', date: '2026-07-01' },
      { no: 87, title: '远古的遗产', date: '2026-06-27' },
      { no: 86, title: '决战前夕', date: '2026-06-23' },
      { no: 85, title: '新的敌人', date: '2026-06-19' },
      { no: 84, title: '联合战线', date: '2026-06-15' },
    ],
  },
];

export const categoryNameMap: Record<string, string> = {
  all: '全部漫画',
  romance: '浪漫爱情',
  action: '热血动作',
  fantasy: '奇幻冒险',
  mystery: '悬疑推理',
  drama: '剧情重生',
  comedy: '搞笑日常',
  horror: '恐怖灵异',
  scifi: '科幻未来',
};